import { getDistributorLevels, getLevels } from "../constants/constant-role";
import { getDistributorLevelsBD, getLevelsBD } from "../constants/constant-role-bd";
import { getDistributorLevelsID, getLevelsID } from "../constants/constant-role-id";
import { getDistributorLevelsKhLa, getLevelsKhLa } from "../constants/constant-role-kh-la";
import { isSpecialBDCountryCodes, isSpecialCountryCode } from "./CountryHelper";

const isKhLaCountry = (selectedCountryCode = "") => {
  const code = String(selectedCountryCode).toLowerCase();
  return code === "kh" || code === "la";
};

export const getLevelForDistributor = (role, selectedCountryCode) => {
    if (isKhLaCountry(selectedCountryCode)) {
      return getDistributorLevelsKhLa(role);
    }

    return isSpecialBDCountryCodes(selectedCountryCode) ? getDistributorLevelsBD(role) : isSpecialCountryCode(selectedCountryCode)
      ? getDistributorLevelsID(role)
      : getDistributorLevels(role);
  };
  
  export const getLevelForNonDistributor = (role, selectedCountryCode) => {
    if (isKhLaCountry(selectedCountryCode)) {
      return getLevelsKhLa(role);
    }

    return isSpecialBDCountryCodes(selectedCountryCode) ? getLevelsBD(role) : isSpecialCountryCode(selectedCountryCode)
      ? getLevelsID(role)
      : getLevels(role);
  };

  export const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];